import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Menu, MenuItem, Typography, useTheme } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { tokens } from '../theme';

const LanguageSelector = memo(() => {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'th', name: 'ไทย', flag: '🇹🇭' },
    { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
    { code: 'my', name: 'မြန်မာ', flag: '🇲🇲' },
    { code: 'lo', name: 'ລາວ', flag: '🇱🇦' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
    handleClose();
  };

  const currentLanguage = languages.find(lang => lang.code === i18n.language);

  return (
    <Box>
      <Button
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 16px',
          borderRadius: '4px',
          backgroundColor: colors.blueAccent[700],
          color: colors.grey[100],
          border: `1px solid ${colors.blueAccent[500]}`,
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: colors.blueAccent[600],
            borderColor: colors.greenAccent[500],
          },
        }}
      >
        <LanguageIcon sx={{ fontSize: '20px' }} />
        <Typography sx={{ fontSize: '14px', fontWeight: '600' }}>
          {currentLanguage?.flag} {currentLanguage?.name}
        </Typography>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: colors.primary[400],
            border: `1px solid ${colors.blueAccent[700]}`,
          },
        }}
      >
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            sx={{
              padding: '10px 20px',
              backgroundColor:
                i18n.language === language.code
                  ? colors.blueAccent[700]
                  : 'transparent',
              color: colors.grey[100],
              '&:hover': {
                backgroundColor: colors.blueAccent[700],
              },
              fontWeight: i18n.language === language.code ? '700' : '400',
            }}
          >
            <Typography sx={{ fontSize: '14px' }}>
              {language.flag} {language.name}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
});

LanguageSelector.displayName = "LanguageSelector";

export default LanguageSelector;
